import React, { Component } from 'react';
import DomainsApi from '../../api/domains';
import Button from '@mui/material/Button';
import Input from '@mui/material/Input';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Checkbox from '@mui/material/Checkbox';
import AccountsApi from '../../api/accounts';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { connect } from 'react-redux';
import { showError, showMessage } from '../../actions/uiActions';
import moment from "moment"
class CRMReport extends Component {
  state = {
    memberships: [1],
    status: ["guest", "customer", "lost"],
    companies: [],
    busy: false,
    domains: [],
    password: "",
    loans: ["PF", "RP", "FB", "GP", "DFR", "DF"],
    from: '',
    to: '',
    downloadingPSLFReport: false,
    currentDate: moment().format('YYYY-MM-DD'),
    twentyDaysAgo: moment().subtract(20, "days").format("YYYY-MM-DD")
  }
  async componentDidMount() {
    try {
      const domains = await DomainsApi.all();
      this.setState({
        busy: false,
        domains,
        companies: domains.map(domain => domain._id)
      });
    } catch (error) {
      this.setState({ busy: false });
      this.props.showError(error);
    }
  }
  downloadPSLFReport = async () => {
    try {
      this.setState({ downloadingPSLFReport: true });
      if (!this.state.from || !this.state.to) {
        this.props.showError("You must select a date range");
        return;
      }
      await AccountsApi.downloadPSLFReport(this.state.from, this.state.to)
      this.setState({ downloadingPSLFReport: false });
    } catch (error) {
      this.props.showError();
      this.setState({ downloadingPSLFReport: false })
    }
  }
  setDate = (type, value) => {
    this.setState({ [type]: value });
  }
  selectDomain = (e, domain) => {
    let companies
    if (this.state.companies.includes(domain._id)) {
      companies = this.state.companies.filter(company => company != domain._id);
    } else {
      companies = [...this.state.companies, domain._id];
    }
    if (!companies.length) {
      this.props.showError("You must select at least one company.");
    } else {
      this.setState({ companies });
    }
  }
  selectMembership = (e, membership) => {
    let memberships = this.state.memberships.includes(membership) ? this.state.memberships.filter(selectedMembership => selectedMembership != membership) : [...this.state.memberships, membership];
    if (memberships.length == 0)
      this.props.showError("You must select at least one Membership Tier");
    else
      this.setState({ memberships });

  }
  selectStatus = (e, status) => {
    let statuses = this.state.status.includes(status) ? this.state.status.filter(selectedStatus => selectedStatus != status) : [...this.state.status, status];
    if (statuses.length === 0)
      this.props.showError("You must select at least one User Status");
    else
      this.setState({ status: statuses });
  }
  selectLoan = (e, loan) => {
    let loans = this.state.loans.includes(loan) ? this.state.loans.filter(selectedLoan => selectedLoan != loan) : [...this.state.loans, loan];
    if (loans.length === 0)
      this.props.showError("You must select at least one Loan Status");
    else
      this.setState({ loans: loans });
  }
  downloadReport = (isDateRange) => {
    let query = ''
    if (isDateRange) {
      const {currentDate, twentyDaysAgo} = this.state
      query = `startDate=${twentyDaysAgo}&endDate=${currentDate}`;
    }
    this.setState({ busy: true }, () => AccountsApi.downloadReport(this.state.companies, this.state.memberships, this.state.status, this.state.loans,query)
      .then((success) => {
        this.props.showMessage("The report is being generated, a mail will be sent to you once it's ready");
        this.setState({ busy: false }, this.props.onClose)
      })
      .catch(error => {
        this.props.showError();
        this.setState({ busy: false })
      }));
  }
  render() {
    const {currentDate, twentyDaysAgo} = this.state
    return <Dialog onClose={this.props.onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description" fullWidth={true} maxWidth="sm" open={true}
    >
      <DialogTitle id="alert-dialog-title">Generate CRM Report</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <h6>Select the Companies to include in the report</h6>
          <div className="row">
            {this.state.domains.map((domain, index) => <div key={`company-${index}`} className="col-6">
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={this.state.busy}
                    checked={this.state.companies.includes(domain._id)}
                    onChange={(e) => this.selectDomain(e, domain)}
                    value={domain._id}
                  />
                }
                label={domain.company}
              />
            </div>)}
          </div>
          <h6>Select the Membership Tiers to include in the report</h6>
          <div className="row">
            <div className="col-4">
              <FormControlLabel
                control={
                  <Checkbox disabled={this.state.busy} checked={this.state.memberships.includes(1)} onChange={(e) => this.selectMembership(e, 1)} value={1} />
                }
                label="Platinum Tier"
              />
            </div>
            <div className="col-4">
              <FormControlLabel
                control={
                  <Checkbox disabled={this.state.busy} checked={this.state.memberships.includes(2)} onChange={(e) => this.selectMembership(e, 2)} value={2} />
                }
                label="Gold Tier"
              />
            </div>
          </div>
          <h6>Select the User Statuses to include in the report</h6>
          <div className="row">
            <div className="col-4">
              <FormControlLabel
                control={
                  <Checkbox disabled={this.state.busy} checked={this.state.status.includes("customer")} onChange={(e) => this.selectStatus(e, "customer")} value={"customer"} />
                }
                label="Customer"
              />
            </div>
            <div className="col-4">
              <FormControlLabel
                control={
                  <Checkbox disabled={this.state.busy} checked={this.state.status.includes("user")} onChange={(e) => this.selectStatus(e, "user")} value={"user"} />
                }
                label="Lead"
              />
            </div>
            <div className="col-4">
              <FormControlLabel
                control={
                  <Checkbox disabled={this.state.busy} checked={this.state.status.includes("lost")} onChange={(e) => this.selectStatus(e, "lost")} value={"lost"} />
                }
                label="Can't Improve"
              />
            </div>
            <div className="col-4">
              <FormControlLabel
                control={
                  <Checkbox disabled={this.state.busy} checked={this.state.status.includes("lead")} onChange={(e) => this.selectStatus(e, "lead")} value={"lead"} />
                }
                label="Abandoned cart"
              />
            </div>
          </div>
          <h6>Only include in the report users with at least one loan:</h6>

          <div className="row">
            <div className="col-4">
              <FormControlLabel
                control={
                  <Checkbox disabled={this.state.busy} checked={this.state.loans.includes("PF")} onChange={(e) => this.selectLoan(e, "PF")} value={"PF"} />
                }
                label="Paid in Full"
              />
            </div>
            <div className="col-4">
              <FormControlLabel
                control={
                  <Checkbox disabled={this.state.busy} checked={this.state.loans.includes("RP")} onChange={(e) => this.selectLoan(e, "RP")} value={"RP"} />
                }
                label="In Repayment"
              />
            </div>
            <div className="col-4">

              <FormControlLabel
                control={
                  <Checkbox disabled={this.state.busy} checked={this.state.loans.includes("FB")} onChange={(e) => this.selectLoan(e, "FB")} value={"FB"} />
                }
                label="In Forbearance"
              />
            </div>
            <div className="col-4">

              <FormControlLabel
                control={
                  <Checkbox disabled={this.state.busy} checked={this.state.loans.includes("GP")} onChange={(e) => this.selectLoan(e, "GP")} value={"GP"} />
                }
                label="In Grace Period"
              />
            </div>

            <div className="col-4">

              <FormControlLabel
                control={
                  <Checkbox disabled={this.state.busy} checked={this.state.loans.includes("DFR")} onChange={(e) => this.selectLoan(e, "DFR")} value={"DFR"} />
                }
                label="In Deferment"
              />
            </div>
            <div className="col-4">

              <FormControlLabel
                control={
                  <Checkbox disabled={this.state.busy} checked={this.state.loans.includes("DF")} onChange={(e) => this.selectLoan(e, "DF")} value={"DF"} />
                }
                label="Defaulted"
              />
            </div>
          </div>
          <h6>PSLF Months report</h6>
          <div className="row">
            <div className="col-4">
              <Input disabled={this.state.busy} type="date" onChange={(e) => this.setDate('from', e.target.value)} />
            </div>
            <div className="col-4">
              <Input disabled={this.state.busy} type="date" onChange={(e) => this.setDate('to', e.target.value)} />
            </div>
            <div className="col-4">
              <Button className="loading" disabled={this.state.downloadingPSLFReport} variant="outlined" onClick={this.downloadPSLFReport} color="primary" autoFocus>
                Download
              </Button>
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-4">
              <p>From:</p>
              <Input disabled={true} value={twentyDaysAgo} type="date" />
            </div>
            <div className="col-4">
              <p>To:</p>
              <Input disabled={true} value={currentDate} type="date" />
            </div>
            <div className="col-4">
              <Button className="loading" disabled={this.state.downloadingPSLFReport} variant="outlined" onClick={() => this.downloadReport(true)} color="primary" autoFocus>
                Download range

              </Button>
            </div>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className="loading" disabled={this.state.busy} variant="outlined" onClick={() => this.downloadReport(false)} color="primary" autoFocus>
          Download Report
        </Button>
        <Button disabled={this.state.busy} onClick={this.props.onClose} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>;
  }

}
export default connect(null, { showError, showMessage })(CRMReport);